import Vue from 'vue'

import { parseTime } from "@/utils/index";

Vue.filter('translateFlag', function (value, list) {
  let curr
  for (let item of list) {
    if (parseInt(item.status) === parseInt(value)) {
      curr = item.label
    }
  }
  return curr
})
Vue.filter('translateNumber', function (value, list) {
  let curr
  value = parseInt(value)
  for (let item of list) {
    if (parseInt(item.status) === parseInt(value)) {
      curr = item.label
    }
  }
  return curr
})
Vue.filter('translateCodeName', function (code, list) {
  let curr
  for (let item of list) {
    if (item.code === code) {
      return item.name
    }
  }
  return curr
})
Vue.filter('translateCodeNameForNumber', function (code, list) {
  // console.log("code, list", code, list)
  code = parseInt(code)
  let curr
  for (let item of list) {
    if (item.code === code) {
      return item.name
    }
  }
  return curr
})

Vue.filter('translateLabelValue', function (value, list) {
  value = parseInt(value)
  for (let item of list) {
    if (item.value === value) {
      return item.label
    }
  }
})
Vue.filter('translateTF', function (value) {
  if (value === 'F') return false
  if (value === 'T') return true
})
Vue.filter('parseTime', function (value) {
  if (!value) return
  var time = parseTime(value)
  return time
})

Vue.filter('translateLockFlag', function (value) {
  return value === 'T' ? 'el-icon-lock' : ''
})
Vue.filter('_parseInt', function (value) {
  return parseInt(value)
})

// translateLockFlag(value) {
//   return value === "T" ? "el-icon-lock" : "";
//   return value;
// },



// WEBPACK FOOTER //
// ./src/filters.js